import { Stack, Typography } from '@mui/material';

export default function EmptyState({
  show,
  img,
  title,
  subtitle,
  width = 162,
  pt = 'calc((100vh / 2)  - 400px)',
  ...props
}) {
  return show ? (
    <Stack alignItems="center" flexGrow={1} pt={pt} {...props}>
      <img src={img} alt="Empty" width={width} />
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body1" textAlign="center">
        {subtitle}
      </Typography>
    </Stack>
  ) : (
    <></>
  );
}
